import { action, observable } from 'mobx';
import { api } from '../config';

// UserStore (used to access user data)
import UserStore from './UserStore';

// AppStore (used for loading, error throwing, etc.)
import AppStore from './AppStore';

import SurveyStore from './SurveyStore';

// Helpers
import { formatQuery } from '../helpers';

const eventNames = {
  PAGE_VIEW: 'Page View',
  RESOURCE_LINK_CLICKED: 'Resource Link Clicked'
};

let obx = observable({
  /**
   * Sends an activity for a given event name
   *
   * @param {string} eventName - Name of the activity event
   * @param {Object} [metaData] - Any additional data for the activity payload
   */
  sendActivity: action((eventName, metaData = {}) => {
    const { assessmentGroupSid, targetUserData, userData, installSid } = UserStore;

    api
      .post(`/installs/${installSid}/users/${userData.userSid}/activity`, {
        eventName,
        eventTimestamp: new Date().toISOString(),
        applicationSid: userData.smarterMeasure.applicationSid,
        applicationInstallSid: userData.installSid,
        metaData: {
          assessmentGroupSid,
          targetUserSid: targetUserData.userSid || userData.userSid,
          ...metaData
        }
      })
      .catch(error => console.error(error));
  }),
  postHeartbeat:  action(async (eventName) => {
    const {assessmentGroupSid, targetUserData, userData} = UserStore;
    let surveyData = SurveyStore.returnSurveyMetaData();

    let response = await api.post(`/surveys/heartbeat`, {
      eventName,
      applicationSid: userData.smarterMeasure.applicationSid,
      applicationInstallSid: userData.installSid,
      metaData: {
        type: 'plgSurvey',
        assessmentGroupSid,
        targetUserSid: targetUserData.userSid,
        userSid: userData.userSid,
        surveyData,
      }
    })

    return response.data;

  }),
  sendHeartbeat: action(async(sid) => {
    await api.patch(`/heartbeat/${sid}`)
  }),
  patchExecuteFalse: action((sid) => {
    api.patch(`/heartbeat/${sid}/execute`)
      .then(() => {})
      .catch(error => {
      AppStore.throwError(error)
      })
  }),

  /**
   * Sends an activity for a page view
   *
   * @param {Object} [data] - Any additional data for the activity payload
   * @param {string} [data.pageUrl] - URL of the page
   * @param {string} [data.view] - Name of the view
   * @param {string} [data.title] - Title of the page
   * @param {string} [data.reportSid] - SID of the report
   */
  sendPageViewActivity: action(data => obx.sendActivity(eventNames.PAGE_VIEW, data)),

  /**
   * Sends an activity for a resource clicked
   *
   * @param {Object} [data] - Any additional data for the activity payload
   * @param {string} [data.url] - URL of the resource
   * @param {string} [data.label] - label of the URL
   * @param {string} [data.reportSid] - SID of the report
   */
  sendResourceLinkClickedActivity: action(data =>
    obx.sendActivity(eventNames.RESOURCE_LINK_CLICKED, data)
  ),

  reportActivity: [],
  reportActivityNext: null,

  /**
   * Get a list of all activity for assessment group
   *
   * @param {Object} [query] - Optional query params for the activity history payload
   * @param {Boolean} [append] -
   * @param {function} [callback] - Optional callback function
   */
  listAssessmentGroupActivity: action((query, append, callback) => {
    const url = `/installs/${UserStore.installSid}/assessmentGroups/${
      UserStore.assessmentGroupSid
    }/activity${formatQuery(query)}`;

    api.get(url)
      .then(response => {
        const { results } = response.data;

        if(!append) {
          obx.reportActivity = results;
        } else {
          obx.reportActivity = obx.reportActivity.concat(results);
        }

        if(response.data.next) {
          obx.reportActivityNext = response.data.next;
        } else {
          obx.reportActivityNext = null;
        }

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        AppStore.throwError(error);
      });
  })
});

export default obx;
